import SIZE from "./size";
import { IoMdCloseCircleOutline } from "react-icons/io";
import CLASSNAME from "./classname";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { toggleScreenPresentation } from "../../../../store/reducers/livestreamSettings";
import { GoArrowUp } from "react-icons/go";
import RoomClient from "components/containers/utils/mediaSoup/RoomClient";
import { socketMessageSubType, socketMessageType } from "config/SocketConstants";
import { User } from "models/User";
import { useCallback, useContext, useEffect } from "react";
import { validateAndCreateSocketIfExist } from "utils/SocketValidator";
import SocketContext from "socket-context";
import { socketContextType } from "index";
import { UserInfoMapperSocketHandler } from "utils/UserInfoMapper";
import { debounce } from "lodash";

interface ShareScreenControlProps {
  roomClient: RoomClient | null;
}

const ShareScreenControl = ({ roomClient }: ShareScreenControlProps) => {
  const settings = useSelector((state: RootState) => state.live.settings);
  const session_id = useSelector((state: RootState) => state.live.settings.roomId);
  const user = useSelector((state: RootState) => state.auth.user as User);
  const dispatch = useDispatch();
  let userInfoHandler = new UserInfoMapperSocketHandler();
  const socketList: socketContextType[] = useContext(SocketContext);

  const handleOnMessage = async (_data: any) => {
    const msg_body = JSON.parse(_data);
    if (msg_body?.type === socketMessageType.SHARE_SCREEN) {
      if (msg_body.sub_type === socketMessageSubType.RESPONSE_TO_SCREEN_SHARE) {
        // If email matches processed further only then
        if (msg_body?.requestorEmail == user?.email) {
          if (msg_body?.action === "trainer_approved") {
            // let user approved screen share
            shareScreen();
          }
          if (msg_body?.action === "trainer_rejected") {
          }
        }
      }
    }
  }

  // useEffect(() => {
  //   userInfoHandler = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
  // }, [])

  const shareScreenTraineeDetails = () => {
    userInfoHandler = validateAndCreateSocketIfExist(session_id, () => { }, socketList);
    userInfoHandler.sendMessage(
      JSON.stringify({
        type: socketMessageType?.SHARE_SCREEN,
        sub_type: socketMessageSubType?.SHARE_TRAINEE_DETAILS,
        action: 'start',
        requestorEmail: user?.email,
        requestorName: user?.name,
        room_id: session_id
      })
    )
  }

  const stopSharingScreenShare = () => {
    userInfoHandler = validateAndCreateSocketIfExist(session_id, () => { }, socketList);
    userInfoHandler.sendMessage(
      JSON.stringify({
        type: socketMessageType?.SHARE_SCREEN,
        sub_type: socketMessageSubType?.SHARE_TRAINEE_DETAILS,
        action: 'stop',
        requestorEmail: user?.email,
        requestorName: user?.name,
        room_id: session_id
      })
    )
  }

  const shareScreen = () => {
    if (roomClient) {
      roomClient.enableShare();
      shareScreenTraineeDetails();
    }
  };

  const toggleScreenShare = useCallback(
    debounce(() => {
      if (settings.isScreenPresented) {
        roomClient?.disableShare();
        stopSharingScreenShare();
      } else {
        userInfoHandler = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
        userInfoHandler.sendMessage(
          JSON.stringify({
            type: socketMessageType.SHARE_SCREEN,
            sub_type: socketMessageSubType.REQUEST_FOR_SHARE_SCREEN,
            requestorEmail: user?.email,
            requestorName: user?.name,
            room_id: session_id,
          })
        );
      }
    }, 500), // 500ms debounce delay
    [settings.isScreenPresented, session_id, user, roomClient, dispatch]
  );

  return (
    <div className="relative group">
      <div
        className={`flex items-center h-12 w-12  largescreen:h-14 largescreen:w-14 justify-center rounded-full cursor-pointer ${!settings.isScreenPresented && "bg-white-600"
          }`}
        style={{
          background: "rgb(95, 72, 138)",
          boxShadow:
            "rgb(152, 122, 209) -8px -8px 16px inset, rgba(2, 2, 2, 0.61) 8px 8px 8px inset",
        }}
        onClick={toggleScreenShare}
      >
        {!settings.isScreenPresented ? (
          <GoArrowUp color="white" size={SIZE} />
        ) : (
          <IoMdCloseCircleOutline color="black" size={SIZE} />
        )}
      </div>


      <div className="absolute bottom-full mb-1 left-1/2 transform -translate-x-1/2 max-w-md bg-black text-white text-sm rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        Share Screen
      </div>
    </div>
  );
};

export default ShareScreenControl;
